import { useQuery } from '@tanstack/react-query';
import { graphqlRequest } from '../utils/graphqlRequest';
import { workoutInfoByIdQuery } from '../constants/queries';
import { useToastContext } from '../components/UI/ToastManager';

type WorkoutInfoByIdQueryResponse = {
  workoutInfo: {
    id: string;
    name: string;
    displayName: Array<{
      language: string;
      text: string;
    }>,
    description: Array<{
      language: string;
      text: string;
    }>;
    lastUpdateDate: string;
    videos: Array<{
      video: {
        source: string;
        title: string;
        duration: string;
      };
      language: string;
    }>;
    poster: {
      source: string;
    };
    selector: {
      focus: string[];
      sport: string[];
      flags: string[];
      timeMin: number;
      timeMax: number;
      distanceMin: number;
      distanceMax: number;
      dplusMin: number;
      dplusMax: number;
    };
    status: string;
  };
};

export function useWorkoutInfoByIdQuery(id: string | null) {
  const { showError } = useToastContext();

  return useQuery<WorkoutInfoByIdQueryResponse['workoutInfo']>({
    queryKey: ['workoutInfo', id],
    queryFn: () => graphqlRequest<WorkoutInfoByIdQueryResponse>(workoutInfoByIdQuery, { id }, showError).then(result => result.workoutInfo),
    enabled: !!id, // Only run query if id is provided
  });
} 